/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface ShopByCategoryStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    container?: GridContainerProps;
    categoryGridItem?: GridItemProps;
    TitleText?: TypographyPresentationProps;
    categoryImage?: InjectableCss;
    categoryLink?: LinkPresentationProps;
    categoryText?: TypographyPresentationProps;
    categoryTextWrapper?: InjectableCss;
    categoryImageWrapper?: InjectableCss;
}

export const shopByCategoryStyles: ShopByCategoryStyles = {
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        color: "primary.main",
        css: css`
            margin: auto;
        `,
    },
    container: {
        css: css`
            max-width: 100%;
            overflow: hidden;
        `,
    },
    categoryGridItem: {},
    TitleText: {
        css: css`
            text-align: left;
        `,
    },
    categoryImage: {
        css: css``,
    },
    categoryLink: {
        css: css`
            &,
            > span {
                width: 100%;
                display: flex;
                flex-direction: column;
            }
            &:hover {
                text-decoration-color: ${getColor("text.main")};
            }
        `,
    },
    categoryText: {
        css: css`
            margin-bottom: 0;
        `,
    },
    categoryTextWrapper: {
        css: css`
            width: 100%;
            text-align: center;
            margin-top: 5px;
        `,
    },
    categoryImageWrapper: {
        css: css`
            width: 100%;
            height: 175px;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            .lazyImage-placeholder {
                line-height: 16px;
            }
        `,
    },
};
